/*
 * File: StudentSectionSkeleton.tsx
 * Author: Austin Robinson
 * Date Created: 12/07/2025
 * Copyright (c) DrivingDoc 2025
 */
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Paper from '@mui/material/Paper';
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';

/**
 * Skeleton loader for StudentSection component
 * Mirrors the structure and spacing of the actual StudentSection
 */
export default function StudentSectionSkeleton() {
  return (
    <Paper elevation={1} sx={{ p: 2 }}>
      {/* Header - Name and Enrollment Type */}
      <Box display="flex" alignItems="center" justifyContent="space-between" flexWrap="wrap" gap={1} mb={2}>
        <Skeleton width="50%" height={32} />
        <Skeleton width={180} height={28} variant="rounded" />
      </Box>

      <Stack gap={2}>
        {/* Student Info - Permit and Balance */}
        <Stack gap={1}>
          <Skeleton width="70%" height={20} />
          <Skeleton width="60%" height={20} />
        </Stack>

        <Divider />

        {/* Attendance Buttons */}
        <Box display="flex" gap={1} flexWrap="wrap">
          <Skeleton width={100} height={36} variant="rounded" />
          <Skeleton width={100} height={36} variant="rounded" />
          <Skeleton width={120} height={36} variant="rounded" />
        </Box>

        <Divider />

        {/* Contact Info Accordion */}
        <Box>
          <Skeleton width="40%" height={22} sx={{ mb: 1 }} />
          <Skeleton width="60%" height={16} />
        </Box>

        <Divider />

        {/* Drive History Accordion */}
        <Box>
          <Skeleton width="35%" height={22} sx={{ mb: 1 }} />
          <Box display="flex" gap={2} flexWrap="wrap">
            <Skeleton width={100} height={20} />
            <Skeleton width={100} height={20} />
            <Skeleton width={100} height={20} />
          </Box>
        </Box>
      </Stack>
    </Paper>
  );
}
